import { render, staticRenderFns } from "./ModalRedoGeneral.vue?vue&type=template&id=135038c0&scoped=true"
import script from "./ModalRedoGeneral.vue?vue&type=script&lang=js"
export * from "./ModalRedoGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135038c0",
  null
  
)

export default component.exports